import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BaseCampaign } from '@feathr/blackbox';
import { DripCampaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const ClicksColumn: IColumn<BaseCampaign> = {
  id: 'clicks',
  checkboxLabel: 'Clicks',
  Header: TableColumnHeader({
    title: 'Clicks',
  }),
  width: 80,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }) {
    return (
      <Observer>
        {function useAnonymousFunction(): JSX.Element {
          const { AggregatedStats } = useStore();
          if (original instanceof DripCampaign) {
            const flavors = original.getAggregateFlavors(AggregatedStats);
            const totalClicks = flavors.pinpoint_tracked_email_click || 0;

            return <>{totalClicks?.toLocaleString()}</>;
          }

          return <>{original.totalClicks.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }) {
    return (
      <Observer>
        {(): JSX.Element => {
          const total = data.reduce((subtotal, currentValue) => {
            return subtotal + currentValue._original.totalClicks;
          }, 0);
          return <>{total.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default ClicksColumn;
